import EntityType from "../../enum/EntityType";
import EmailDynamicVariable from "../../types/email/EmailDynamicVariable";
import { EntityTypesSupportedByEmailFeature } from "../../types/entity";

export const EMAIL_DYNAMIC_VARIABLE_REGEX = new RegExp(
  `{{(?<prefix>(std|cf)):(?<entityType>(${EntityType.COMPANY}|${EntityType.PERSON})):(?<name>[a-zA-Z0-9._-]+)}}`,
  "g"
);

export const parseEmailDynamicVariableMatch = (
  match: RegExpMatchArray
): {
  entityType: EntityTypesSupportedByEmailFeature;
  name: EmailDynamicVariable["name"];
  prefix: EmailDynamicVariable["prefix"];
  value: string;
} => {
  return {
    entityType: match.groups?.["entityType"] as EntityTypesSupportedByEmailFeature,
    name: match.groups?.["name"] as string,
    prefix: match.groups?.["prefix"] as EmailDynamicVariable["prefix"],
    value: match[0],
  };
};

const parseEmailDynamicVariables = (
  value: string
): {
  entityType: EntityTypesSupportedByEmailFeature;
  name: EmailDynamicVariable["name"];
  prefix: EmailDynamicVariable["prefix"];
  value: string;
}[] => {
  return Array.from(value.matchAll(EMAIL_DYNAMIC_VARIABLE_REGEX)).map(
    parseEmailDynamicVariableMatch
  );
};

export default parseEmailDynamicVariables;
